const locale = {
	DETAILS_EXCH_MAIL_LOGS_IMPORT_DATE: 'Import date',
	DETAILS_EXCH_MAIL_LOGS_DIRECTION: 'Direction',
	DETAILS_EXCH_MAIL_LOGS_SENDER: 'Sender',
	DETAILS_EXCH_MAIL_LOGS_RECIPIENT: 'Recipient',
	DETAILS_EXCH_MAIL_LOGS_SENT_DATE: 'Send date',
	DETAILS_EXCH_MAIL_LOGS_SUBJECT: 'Subject',
	DETAILS_EXCH_MAIL_LOGS_ERROR: 'Error',

	EXCH_MAIL_ERROR_UNKNOWN_MAIL: 'Unknown mail',
	EXCH_MAIL_ERROR_MAIL_NO_LINK: 'Mail not linked',
	EXCH_MAIL_ERROR_UNKNOWN_COMPANY: 'Unknown company',
	EXCH_MAIL_ERROR_NO_FOLDERNAME: 'No folder name',
	EXCH_MAIL_ERROR_ALREADY_IMPORTED: 'Message already imported',
	EXCH_MAIL_ERROR_DUPLICATE_FILE: 'Duplicate file name'
};

export default locale;
